import { LinkedIdModel } from 'src/app/core/models/impact-assessment/linked-id-model';

export class SimilarRegulationModel {
  id: number;
  mappingID: string;
  regulator!: string;
  date: Date;
  pubType: string;
  title: string;

  constructor() {
    this.id = 0;
    this.mappingID = '';
    this.date = new Date();
    this.pubType = '';
    this.title = '';
  }
}

export class SimilarRegulationDataModel {
  similarRegulations: SimilarRegulationModel[];
  closedIds: Array<number>;
  impactAssessmentIds: Array<LinkedIdModel>;

  constructor() {
    this.similarRegulations = [];
    this.closedIds = [];
    this.impactAssessmentIds = [];
  }
}
